import { Flex, Text } from '@podiumhq/design-system';

export const campaignContent = (
  <Flex flexDir="column">
    <Text color="black.base" fontSize="sm">
      Hi Teddy, this is Julie at Beachside Floral. We want to give you 10% off
      your next purchase! Use code THANKS at checkout. 🌸 Shop now:
      https://www.beachsidefloral.com/
    </Text>
    <Text color="black.base" fontSize="sm" mt="16px">
      Reply REMOVE to unsubscribe from marketing messages.
    </Text>
  </Flex>
);

export const customerResponse = (
  <Text color="black.base" fontSize="sm">
    Thank you! Just in time for my girlfriend’s birthday.
  </Text>
);

export const businessResponse = (
  <Text color="black.base" fontSize="sm">
    Sounds like great timing! Glad we could help.
  </Text>
);

export const testimonialText =
  '“We quickly put together a texting campaign and we sold out a workshop in 3 days. It’s a game changer for how we communicate to customers.”';

export const testimonialAttribution = 'Robyn Bilson | Pete’s Greenhouse ';
